
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 115.3 115.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.9 14.306L26 30.706H6c-3.3 0-6 2.7-6 6v41.8c0 3.301 2.7 6 6 6h20l21.9 16.4c4 3 9.6.2 9.6-4.8v-77c0-5-5.7-7.8-9.6-4.8zM77.3 24.106c-2.7-2.7-7.2-2.7-9.899 0-2.7 2.7-2.7 7.2 0 9.9 13 13 13 34.101 0 47.101-2.7 2.7-2.7 7.2 0 9.899 1.399 1.4 3.199 2 4.899 2s3.601-.699 4.9-2.1c18.6-18.3 18.6-48.3.1-66.8z"}}),_c('path',{attrs:{"d":"M85.1 8.406c-2.699 2.7-2.699 7.2 0 9.9 10.5 10.5 16.301 24.4 16.301 39.3s-5.801 28.8-16.301 39.3c-2.699 2.7-2.699 7.2 0 9.9 1.4 1.399 3.2 2.1 4.9 2.1 1.8 0 3.6-.7 4.9-2 13.1-13.1 20.399-30.6 20.399-49.2s-7.2-36-20.399-49.2c-2.6-2.8-7-2.8-9.8-.1z"}})])
          )
        }
      }
    